
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/[game]",
      function () {
        return require("private-next-pages/play/[game].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/[game]"])
      });
    }
  